import { render, staticRenderFns } from "./Sanmak.vue?vue&type=template&id=58b38205&scoped=true"
import script from "./Sanmak.vue?vue&type=script&lang=js"
export * from "./Sanmak.vue?vue&type=script&lang=js"
import style0 from "./Sanmak.vue?vue&type=style&index=0&id=58b38205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b38205",
  null
  
)

export default component.exports